// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3GLrH","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1iCqK"};